import { useEffect, useRef, useState } from "react";

const tabs = [
  "Signing Up & Onboarding",
  "Exploring Tutorial",
  "Logging In",
  "Subscribing",
  "Adding to Cart",
  "Adding & Creating",
  "Adding & Inviting People",
  "Chatting & Messaging",
  "Editing",
  "Canceling Subscription",
  "Deleting Account",
  "Resetting Password",
  "Booking",
  "Checking Out",
  "Money Transferring",
];

export default function FlowsTabs(props) {
  const [activeTab, setActiveTab] = useState("Signing Up & Onboarding");
  const tabRefs = useRef({}); // store refs for each tab
  const [items, setItems] = useState(tabs);
  useEffect(() => {
    let dropdownItems = props?.items.flatMap(
      (category) =>
        category.items?.filter((item) => item.status === true) ?? [],
    );
    setItems(dropdownItems);
    setActiveTab();
    setActiveTab(props?.active);
    tabRefs.current[props?.active]?.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest",
    });
  }, [props?.items]);
  const handleTabClick = (tab) => {
    setActiveTab(tab.displayName);
    // auto-scroll to clicked tab
    props?.reload(tab?.title);
    tabRefs.current[tab?.displayName]?.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest",
    });
  };

  return items.length ? (
    <div className="w-full overflow-x-auto scrollbar-hide py-4 static top-0 right-0 z-10">
      <div className="flex gap-2 min-w-max px-2">
        {items.map((tab, index) => (
          <button
            key={index}
            ref={(el) => (tabRefs.current[tab?.displayName] = el)}
            onClick={() => handleTabClick(tab)}
            className={`px-5 py-2 rounded-full border text-sm font-medium whitespace-nowrap transition
              ${
                activeTab === tab?.displayName
                  ? "bg-black text-white"
                  : "bg-white text-black border-gray-200 hover:bg-gray-100"
              }`}
          >
            {tab.displayName?.toString().charAt(0).toUpperCase() +
              tab.displayName?.toString().slice(1).toLowerCase()}
          </button>
        ))}

        {/* "More" Button */}
        <button className="px-5 py-2 rounded-full border border-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-100 whitespace-nowrap">
          More <span className="text-gray-400">21</span>
        </button>
      </div>
    </div>
  ) : (
    <></>
  );
}
